<template>
    <v-card class="brushstroke-banner brushstroke background_white" :class="brushstrokeColor + '-brushstroke'" :id="baseId">
        <slot></slot>
    </v-card>
</template>

<script>

export default {
    computed: {
        baseId: function () {
            const defaultBase = 'brushstroke-banner'
            if (this.parentId) {
                return `${this.parentId}-${defaultBase}`
            } else {
                return defaultBase
            }
        }
    },
    props: {
        brushstrokeColor: {
            type: String,
            required: false,
            default: 'blue',
            validator (value) {
                return ['blue', 'green'].indexOf(value) >= 0
            }
        },
        parentId: {
            type: String,
            required: false,
            default: ''
        }
    }
}

</script>

<style lang="scss" scoped>

.background_white{
    background-color: #fff;
}

.brushstroke-banner {
    position: relative;
    padding: 14px 40px;
    border-radius: 0 !important;
    border: 1px solid #CED0D0 !important;
    box-shadow: none !important;
    text-transform: uppercase;

    @media (max-width: 960px) {
        & {
            padding: 9px 16px;
        }
    }
}

.brushstroke {
    background-size: 550px;
    background-position: right -140px bottom 15%;
    background-repeat: no-repeat;
}

.blue-brushstroke {
    background-image: url(~@/assets/brushstroke_blue.svg);
}

.green-brushstroke {
    background-image: url(~@/assets/brushstroke_green.svg);
}

@media (min-width: 500px) {
    .brushstroke {
        background-size: 600px;
    }
}

@media (min-width: 960px) {
    .brushstroke {
        background-size: 700px;
    }
}

</style>
